export default __webpack_public_path__ + "static/media/cylinder.8176269b.svg";